// extracted by mini-css-extract-plugin
export default {"closeIcon":"styles-module__closeIcon__src-labstep-web-core-Segment-_RC1Ht"};